export default __webpack_public_path__ + "static/media/section3.1f2f6e3e.jpg";